import React, { useState } from "react";
import * as XLSX from "xlsx";

export default function UnitRampasanTable({ data }) {
  const [view, setView] = useState("Rampasan");
  const [filterDate, setFilterDate] = useState("");

  if (!data || data.length === 0) {
    return (
      <div className="p-6 bg-white rounded-md shadow-md text-center">
        <h2 className="text-xl font-bold mb-4">UNIT RAMPASAN</h2>
        <p>No data available</p>
      </div>
    );
  }

  // Filter by date (based on updatedAt)
  const filteredData = filterDate
    ? data.filter(
        (item) =>
          new Date(item.updatedAt).toISOString().split("T")[0] === filterDate
      )
    : data;

  // Latest updated date
  const latestUpdate = new Date(
    Math.max(...data.map((item) => new Date(item.updatedAt)))
  );

  // Download Excel based on current view
  const handleDownloadExcel = () => {
    let sheetData = [];

    if (view === "Rampasan") {
      sheetData = filteredData.map((item, index) => ({
        Bil: index + 1,
        Kawasan: item.areaId,
        Nama: item.name,
        "No. Unit": item.unitNumber,
        "No. Akaun": item.accountNumber,
        "Jumlah Tunggakan": item.arrears.toFixed(2),
        Catatan: `Rampas ${new Date(item.updatedAt).toLocaleDateString("en-GB")}`,
      }));
    } else if (view === "Tamat Kontrak") {
      sheetData = filteredData.map((item, index) => ({
        Bil: index + 1,
        Kawasan: item.areaId,
        Nama: item.name,
        "Jenis Kontrak": item.contractType,
        "Tarikh Mula": new Date(item.contractStartDate).toLocaleDateString("en-GB"),
        "Tarikh Tamat": new Date(item.contractEndDate).toLocaleDateString("en-GB"),
        "Imej Kontrak": item.contractImage,
      }));
    }

    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, view);
    XLSX.writeFile(wb, `${view.replace(" ", "_")}_Data.xlsx`);
  };

  return (
    <div className="p-6 bg-white rounded-md shadow-md">
      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <h2 className="text-xl font-bold mb-3 md:mb-0">UNIT RAMPASAN</h2>

        <div className="flex items-center space-x-3">
          <input
            type="date"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
            className="border px-2 py-1 rounded-md"
          />
          <button
            onClick={() => setView("Rampasan")}
            className={`py-2 px-3 rounded-md text-white ${
              view === "Rampasan" ? "bg-blue-600" : "bg-blue-500"
            }`}
          >
            Rampasan
          </button>
          <button
            onClick={() => setView("Tamat Kontrak")}
            className={`py-2 px-3 rounded-md text-white ${
              view === "Tamat Kontrak" ? "bg-blue-600" : "bg-blue-500"
            }`}
          >
            Tamat Kontrak
          </button>
        </div>
      </div>

      {/* Rampasan Table */}
      {view === "Rampasan" && (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-700 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-3 py-2">Bil.</th>
                <th className="border px-3 py-2">Kawasan</th>
                <th className="border px-3 py-2">Nama</th>
                <th className="border px-3 py-2">No. Unit</th>
                <th className="border px-3 py-2">No. Akaun</th>
                <th className="border px-3 py-2">Jumlah Tunggakan</th>
                <th className="border px-3 py-2">Catatan</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.id}>
                  <td className="border px-3 py-2 text-center">{index + 1}</td>
                  <td className="border px-3 py-2">{item.areaId}</td>
                  <td className="border px-3 py-2">{item.name}</td>
                  <td className="border px-3 py-2">{item.unitNumber}</td>
                  <td className="border px-3 py-2">{item.accountNumber}</td>
                  <td className="border px-3 py-2">
                    RM {item.arrears.toLocaleString()}
                  </td>
                  <td className="border px-3 py-2">
                    Rampas {new Date(item.updatedAt).toLocaleDateString("en-GB")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Tamat Kontrak Table */}
      {view === "Tamat Kontrak" && (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-700 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-3 py-2">Bil.</th>
                <th className="border px-3 py-2">Kawasan</th>
                <th className="border px-3 py-2">Nama</th>
                <th className="border px-3 py-2">Jenis Kontrak</th>
                <th className="border px-3 py-2">Tarikh Mula</th>
                <th className="border px-3 py-2">Tarikh Tamat</th>
                <th className="border px-3 py-2">Imej Kontrak</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.id}>
                  <td className="border px-3 py-2 text-center">{index + 1}</td>
                  <td className="border px-3 py-2">{item.areaId}</td>
                  <td className="border px-3 py-2">{item.name}</td>
                  <td className="border px-3 py-2">{item.contractType}</td>
                  <td className="border px-3 py-2">
                    {new Date(item.contractStartDate).toLocaleDateString("en-GB")}
                  </td>
                  <td className="border px-3 py-2">
                    {new Date(item.contractEndDate).toLocaleDateString("en-GB")}
                  </td>
                  <td className="border px-3 py-2">
                    <img
                      src={item.contractImage}
                      alt="Contract"
                      className="w-20 h-14 object-cover rounded-md"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Footer */}
      <div className="flex justify-between items-center mt-4">
        <p className="text-sm">
          Dikemaskini pada: {latestUpdate.toLocaleDateString("en-GB")}
        </p>
        <button
          onClick={handleDownloadExcel}
          className="bg-green-500 text-white px-4 py-2 rounded-md"
        >
          Download Excel
        </button>
      </div>
    </div>
  );
}
